import { render, staticRenderFns } from "./TransactionCategory.vue?vue&type=template&id=7b821709&"
import script from "./TransactionCategory.vue?vue&type=script&lang=js&"
export * from "./TransactionCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports